import React, { Fragment, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faEdit,
    faClipboardList,
    faUserCircle,
    faDollarSign,
    faCalendarMinus,
    faMinusCircle,
    faPlusCircle,
    faCalendarPlus,
    faMoneyCheckAlt,
} from '@fortawesome/free-solid-svg-icons'

// router
import { withRouter } from 'react-router-dom'

// components
import Header from '../Header/Header'
import BotonBack from '../Utiles/BotonBack'
import Subtitulo from '../Utiles/Subtitulo'

// services
import { editByIdCuentasCorriente } from '../../Services/cuentaCorrienteClienteService'
import { saveError } from '../../Services/errorService'

// alert swal
import Swal from 'sweetalert2'

const EditCuentaCorriente = ({ history, location }) => {
    const montoMaximoRef = useRef('')
    const cantidadCuotasMaximasRef = useRef('')
    const debeRef = useRef('')
    const haberRef = useRef('')
    const fechaUltimoPagoRef = useRef('')
    const fechaProximoPagoRef = useRef('')

    const cuentaCorriente = location.state.cuentaCorriente

    const editSucursalSubmit = (e) => {
        e.preventDefault()
        // validaciones

        // formamos la sucursal editada
        let cuentaCorrienteUpdated = {
            id: parseInt(cuentaCorriente.id, 10),
            montoMaximo: montoMaximoRef.current.value,
            cantidadCuotasMaximas: cantidadCuotasMaximasRef.current.value,
            debe: debeRef.current.value,
            haber: haberRef.current.value,
            fechaUltimoPago: fechaUltimoPagoRef.current.value,
            fechaProximoPago: fechaProximoPagoRef.current.value,
        }

        editByIdCuentasCorriente(cuentaCorrienteUpdated)
            .then((res) => {
                history.goBack()
            })
            .catch(async (error) => {
                const errorData = {
                    mensaje: 'Error al intentar editar una cuenta corriente',
                    detalle: error.response.data.message,
                    entidad: 'CUENTA_CORRIENTE_CLIENTE',
                    tipo: 'WEBAPP',
                    severidad: 'HIGH',
                    reportado: 'APPLICATION',
                }

                await saveError(errorData)
                Swal.fire({
                    title: 'Error al editar la cuenta corriente',
                    type: 'warning',
                    showConfirmButton: false,
                    timer: 1000,
                })
            })
    }

    const isDateNull = (fecha) => {
        if (fecha === null) return null
        else {
            let fechaFinal = fecha.split('T')[0]
            return fechaFinal
        }
    }

    return (
        <Fragment>
            <Header />
            <div className="container-fluid mt-3">
                <div className="alert alert-dismissible alert-secondary d-flex justify-content-between">
                    <BotonBack />
                    <Subtitulo
                        icon={faClipboardList}
                        title={'Cuentas Corrientes'}
                    />
                </div>

                <div className="bg-gris p-4">
                    <form onSubmit={editSucursalSubmit}>
                        <div className="form-row">
                            <div className="form-group col-md-6">
                                <label htmlFor="inputCliente">Cliente</label>
                                <div className="input-group-prepend">
                                    <span
                                        className="input-group-text"
                                        id="inputGroupPrepend"
                                    >
                                        <FontAwesomeIcon icon={faUserCircle} />
                                    </span>
                                    <input
                                        type="text"
                                        id="inputClinete"
                                        name="cliente"
                                        className="form-control"
                                        defaultValue={(
                                            cuentaCorriente.cliente.id.persona
                                                .apellido +
                                            ', ' +
                                            cuentaCorriente.cliente.id.persona
                                                .nombre
                                        ).toLocaleUpperCase()}
                                        disabled
                                    />
                                </div>
                            </div>

                            <div className="form-group col-md-6">
                                <label htmlFor="inputMontoMaximo">
                                    Monto Maximo
                                </label>
                                <div className="input-group-prepend">
                                    <span
                                        className="input-group-text"
                                        id="inputGroupPrepend"
                                    >
                                        <FontAwesomeIcon icon={faDollarSign} />
                                    </span>
                                    <input
                                        type="text"
                                        id="inputMontoMaximo"
                                        name="montoMaximo"
                                        className="form-control"
                                        placeholder="Ej. Piedras 2120..."
                                        ref={montoMaximoRef}
                                        defaultValue={
                                            cuentaCorriente.montoMaximo
                                        }
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group col-md-6">
                                <label htmlFor="inputDebe">Debe</label>
                                <div className="input-group-prepend">
                                    <span
                                        className="input-group-text"
                                        id="inputGroupPrepend"
                                    >
                                        <FontAwesomeIcon icon={faMinusCircle} />
                                    </span>
                                    <input
                                        type="text"
                                        id="inputDebe"
                                        name="debe"
                                        className="form-control"
                                        ref={debeRef}
                                        defaultValue={cuentaCorriente.debe}
                                    />
                                </div>
                            </div>

                            <div className="form-group col-md-6">
                                <label htmlFor="inputHaber">Favor</label>
                                <div className="input-group-prepend">
                                    <span
                                        className="input-group-text"
                                        id="inputGroupPrepend"
                                    >
                                        <FontAwesomeIcon icon={faPlusCircle} />
                                    </span>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="inputHaber"
                                        name="haber"
                                        ref={haberRef}
                                        defaultValue={cuentaCorriente.haber}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group col-md-6">
                                <label htmlFor="inputUltimoPago">
                                    Fecha Ultimo Pago
                                </label>
                                <div className="input-group-prepend">
                                    <span
                                        className="input-group-text"
                                        id="inputGroupPrepend"
                                    >
                                        <FontAwesomeIcon
                                            icon={faCalendarMinus}
                                        />
                                    </span>
                                    <input
                                        type="date"
                                        id="inputUltimoPago"
                                        name="ultimoPago"
                                        className="form-control"
                                        ref={fechaUltimoPagoRef}
                                        defaultValue={isDateNull(
                                            cuentaCorriente.fechaUltimoPago
                                        )}
                                    />
                                </div>
                            </div>

                            <div className="form-group col-md-6">
                                <label htmlFor="inputProximoPago">
                                    Fecha Proximo Pago
                                </label>
                                <div className="input-group-prepend">
                                    <span
                                        className="input-group-text"
                                        id="inputGroupPrepend"
                                    >
                                        <FontAwesomeIcon
                                            icon={faCalendarPlus}
                                        />
                                    </span>
                                    <input
                                        type="date"
                                        className="form-control"
                                        id="inputProximoPago"
                                        name="proximoPago"
                                        ref={fechaProximoPagoRef}
                                        defaultValue={isDateNull(
                                            cuentaCorriente.fechaProximoPago
                                        )}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group col-md-6">
                                <label htmlFor="inputMaximoCuotas">
                                    Cantidad Maximo Cuotas
                                </label>
                                <div className="input-group-prepend">
                                    <span
                                        className="input-group-text"
                                        id="inputGroupPrepend"
                                    >
                                        <FontAwesomeIcon
                                            icon={faMoneyCheckAlt}
                                        />
                                    </span>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="inputMaximoCuotas"
                                        name="maximoCuotas"
                                        ref={cantidadCuotasMaximasRef}
                                        defaultValue={
                                            cuentaCorriente.cantidadCuotasMaximas
                                        }
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="text-center">
                            <button
                                type="submit"
                                className="btn btn-outline-danger"
                            >
                                <FontAwesomeIcon icon={faEdit} /> Editar Cuenta
                                Corriente
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </Fragment>
    )
}

export default withRouter(EditCuentaCorriente)
